import axios from 'axios';

const API_HOST = process.env.REACT_APP_API_BASE_PATH;

export const getGochiChildFoodListData = params =>
  axios.get(`${API_HOST}/childShop/foods`, { params, withCredentials: true });

export const getGochiChildFoodListDetailData = childFoodListId =>
  axios.get(`${API_HOST}/childShop/foods/${childFoodListId}`, {
    withCredentials: true
  });

export const addGochiChildFoodListData = params =>
  axios.post(`${API_HOST}/childShop/foods`, params, { withCredentials: true });

export const editGochiChildFoodListData = (childFoodListId, params) =>
  axios.put(`${API_HOST}/childShop/foods`, params, {
    withCredentials: true
  });

export const deleteGochiChildFoodListData = childFoodListId =>
  axios.delete(`${API_HOST}/childShop/foods/${childFoodListId}`, {
    withCredentials: true
  });

// export const showHideGochiMenuData = (menuId, params) =>
//   axios.put(`${API_HOST}/menus/${menuId}/showHide`, params, {
//     withCredentials: true
//   });

export const addGochiChildFoodListImageData = (childFoodListId, params) =>
  axios.post(`${API_HOST}/childShop/foods/${childFoodListId}/image`, params, {
    withCredentials: true
  });

export const getChildFoodGroupsData = params =>
  axios.get(`${API_HOST}/options/groupCreateFood`, {
    params,
    withCredentials: true
  });

export const getChildFoodShopsData = params =>
  axios.get(`${API_HOST}/options/shopCreateFood`, {
    params,
    withCredentials: true
  });
